<template>
    <div>
        <div class="operative-register-widget hidden-mobile">
            <heading colour="white" size="medium" no-margin>Operative Planning</heading>

            <p>Log what operatives are present or booked on a project by signing the operative register.</p>

          <ui-button :href="url" class="mt-4" colour="white">Go To Operative Planning</ui-button>
        </div>
        <div class="hidden-desktop dashboard-component-icon">
          <heading colour="white" size="medium">Operative Planning</heading>
            <a :href="url"><i class="fa fa-users"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props:['url'],
        data() {
            return {
                loaded:true
            };
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {
            var that = this;
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon {
        background-color: $brand;
    }
    .operative-register-widget {
        @include clearfix();
        background-color: $brand;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: $brand;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #e2e6ff;
            }
        }
    }
</style>
